var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 6 8.5)",
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 4 6.5)",
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 2 4.5)",
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 0 2.5)",
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10.5,
    width: 2,
    height: 2,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.0dcfceb6bf40e63f85c1a2579e7c9c56.svg";
export { ForwardRef as ReactComponent };